import { FormGroup } from '@angular/forms';

export class WizardStep {
  id: number;
  code: string;
  label: string;
  title: string;
  route: string;
  form: FormGroup;
  validStep = true;
  // Bind this property on Wizard Step Icons, when user click next with invalid state, this value will be false and step turn red
}
